import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Procrastination',
  slug: 'procrastination',
  category: 'Procrastination',
  date: '2025-05-16',
  image: '',
  excerpt: 'Some ideas to help stop procrastinating.',
  body: `Some ideas to help stop procrastinating.

Procrastination. A few thoughts. First, a question.

Why?

Why are you procrastinating? How might you reframe it?

- Fear of failure? What's the worst possible thing that can happen? Can you live with that?
- Perfectionism? Here's a thought: DONE is better than PERFECT.
- Not interested? Then why are you doing it? Get it over with or don't have it on your list of things to do.
- Overwhelmed? Break it down.

## Ideas on Getting it Done

Here are some techniques.

1. Break down tasks into smaller, actionable steps to make them achievable and less daunting.
2. Set specific goals and deadlines to create a sense of urgency and help you stay focused and accountable.
3. Create a schedule or to-do list – plan the day in advance and prioritize tasks based on importance and urgency.
4. Try different time-management techniques. The Pomodoro Technique works in focused intervals followed by short breaks. Time blocking dedicates specific time slots to specific tasks. The Eisenhower Matrix prioritizes tasks based on importance and urgency. Explore what works for you.`,
}

export default post
